class DialogHandler {
  constructor() {
    document.addEventListener('click', e => this.handleClick(e))
  }

  handleClick(e) {
    const link = e.target.closest('[href*="#modal-"]')
    const trigger = e.target.closest('[data-modal]')
    const closeBtn = e.target.closest('[data-modal-close]')
    const dialog = e.target.closest('dialog')


    if (trigger || link) {
      e.preventDefault()
      e.stopPropagation()

      const id = trigger
        ? trigger.dataset.modal
        : new URL(link.href).hash.slice(1)

      this.showModal(id)
      return
    }

    if (closeBtn) {
      closeBtn.closest('dialog')?.close()
      return
    }

    if (e.target === dialog) {
      dialog?.close()
    }
  }

  showModal(id) {
    const modal = document.getElementById(id)
    if (!modal || modal.nodeName !== 'DIALOG') return

    if (!modal.open) {
      modal.showModal()
    }
  }
}

export default DialogHandler